/**
 * @param {Array} arr
 * @param {Function} fn
 * @description 遍历数组
 */
export const forEach = (arr, fn) => {
  if (!arr.length || !fn) return
  let i = -1
  let len = arr.length
  while (++i < len) {
    let item = arr[i]
    fn(item, i, arr)
  }
}
/**
 * @param {Array} arr1
 * @param {Array} arr2
 * @description 得到两个数组的交集, 两个数组的元素为数值或字符串
 */
export const getIntersection = (arr1, arr2) => {
  let len = Math.min(arr1.length, arr2.length)
  let i = -1
  let res = []
  while (++i < len) {
    const item = arr2[i]
    if (arr1.indexOf(item) > -1) res.push(item)
  }
  return res
}

/**
 * @param {Array} arr1
 * @param {Array} arr2
 * @description 得到两个数组的并集, 两个数组的元素为数值或字符串
 */
export const getUnion = (arr1, arr2) => {
  return Array.from(new Set([...arr1, ...arr2]))
}

/**
 * @param {Array} target 目标数组
 * @param {Array} arr 需要查询的数组
 * @description 判断要查询的数组是否至少有一个元素包含在目标数组中
 */
export const hasOneOf = (targetarr, arr) => {
  return targetarr.some(_ => arr.indexOf(_) > -1)
}

/**
 * @param {String|Number} value 要验证的字符串或数值
 * @param {*} validList 用来验证的列表
 */
export function oneOf (value, validList) {
  for (let i = 0; i < validList.length; i++) {
    if (value === validList[i]) {
      return true
    }
  }
  return false
}

/**
 * @param {Number} timeStamp 判断时间戳格式是否是毫秒
 * @returns {Boolean}
 */
const isMillisecond = timeStamp => {
  const timeStr = String(timeStamp)
  return timeStr.length > 10
}

/**
 * @param {Number} timeStamp 传入的时间戳
 * @param {Number} currentTime 当前时间时间戳
 * @returns {Boolean} 传入的时间戳是否早于当前时间戳
 */
const isEarly = (timeStamp, currentTime) => {
  return timeStamp < currentTime
}

/**
 * @param {Number} num 数值
 * @returns {String} 处理后的字符串
 * @description 如果传入的数值小于10，即位数只有1位，则在前面补充0
 */
const getHandledValue = num => {
  return num < 10 ? '0' + num : num
}

/**
 * @param {Number} timeStamp 传入的时间戳
 * @param {Number} startType 要返回的时间字符串的格式类型，传入'year'则返回年开头的完整时间
 */
export const getDate = (timeStamp, startType) => {
  const d = new Date(timeStamp * 1000)
  const year = d.getFullYear()
  const month = getHandledValue(d.getMonth() + 1)
  const date = getHandledValue(d.getDate())
  const hours = getHandledValue(d.getHours())
  const minutes = getHandledValue(d.getMinutes())
  const second = getHandledValue(d.getSeconds())
  let resStr = ''
  if (startType === 'year') resStr = year + '-' + month + '-' + date + ' ' + hours + ':' + minutes + ':' + second
  else resStr = month + '-' + date + ' ' + hours + ':' + minutes
  return resStr
}

/**
 * @param {String|Number} timeStamp 时间戳
 * @returns {String} 相对时间字符串
 */
export const getRelativeTime = timeStamp => {
  // 判断当前传入的时间戳是秒格式还是毫秒
  const IS_MILLISECOND = isMillisecond(timeStamp)
  // 如果是毫秒格式则转为秒格式
  if (IS_MILLISECOND) Math.floor(timeStamp /= 1000)
  // 传入的时间戳可以是数值或字符串类型，这里统一转为数值类型
  timeStamp = Number(timeStamp)
  // 获取当前时间时间戳
  const currentTime = Math.floor(Date.parse(new Date()) / 1000)
  // 判断传入时间戳是否早于当前时间戳
  const IS_EARLY = isEarly(timeStamp, currentTime)
  // 获取两个时间戳差值
  let diff = currentTime - timeStamp
  // 如果IS_EARLY为false则差值取反
  if (!IS_EARLY) diff = -diff
  let resStr = ''
  const dirStr = IS_EARLY ? '前' : '后'
  // 少于等于59秒
  if (diff <= 59) resStr = diff + '秒' + dirStr
  // 多于59秒，少于等于59分钟59秒
  else if (diff > 59 && diff <= 3599) resStr = Math.floor(diff / 60) + '分钟' + dirStr
  // 多于59分钟59秒，少于等于23小时59分钟59秒
  else if (diff > 3599 && diff <= 86399) resStr = Math.floor(diff / 3600) + '小时' + dirStr
  // 多于23小时59分钟59秒，少于等于29天59分钟59秒
  else if (diff > 86399 && diff <= 2623859) resStr = Math.floor(diff / 86400) + '天' + dirStr
  // 多于29天59分钟59秒，少于364天23小时59分钟59秒，且传入的时间戳早于当前
  else if (diff > 2623859 && diff <= 31567859 && IS_EARLY) resStr = getDate(timeStamp)
  else resStr = getDate(timeStamp, 'year')
  return resStr
}

/**
 * @param {String} t 秒
 * @description 格式化以秒为单位的时长
 */
export const longFormat = (t) => {
  let time = parseInt(t)
  if (time < 60) {
    return time + '秒'
  } else if (time < 60 * 60) {
    return Math.floor(time / 60) + '分钟' + (time % 60) + '秒'
  } else if (time < 60 * 60 * 60) {
    let hours = Math.floor(time / 3600)
    let minutes = Math.floor((time % 3600) / 60)
    let seconds = time % 60
    return hours + '小时' + minutes + '分钟' + seconds + '秒'
  }
}
/**
 * @param {Number} timeStamp 传入的时间戳 单位ms
 * @param {String} format 时间格式 'YYYY-MM-DD', 'MM-DD', 'YYYY-MM', 'YYYY-MM-DD hh:mm:ss'
 */
export const dateFormat = (timeStamp, format) => {
  const d = new Date(timeStamp)
  const year = d.getFullYear()
  const month = getHandledValue(d.getMonth() + 1)
  const date = getHandledValue(d.getDate())
  const hours = getHandledValue(d.getHours())
  const minutes = getHandledValue(d.getMinutes())
  const second = getHandledValue(d.getSeconds())
  const dateObj = {
    'Y+': year,
    'M+': month,
    'D+': date,
    'h+': hours,
    'm+': minutes,
    's+': second
  }
  for (let prop in dateObj) {
    if (new RegExp('(' + prop + ')').test(format)) {
      format = format.replace(RegExp.$1, dateObj[prop])
    }
  }
  return format
}
/**
 * @returns {String} 当前浏览器名称
 */
export const getExplorer = () => {
  const ua = window.navigator.userAgent
  const isExplorer = (exp) => {
    return ua.indexOf(exp) > -1
  }
  if (isExplorer('MSIE')) return 'IE'
  else if (isExplorer('Firefox')) return 'Firefox'
  else if (isExplorer('Chrome')) return 'Chrome'
  else if (isExplorer('Opera')) return 'Opera'
  else if (isExplorer('Safari')) return 'Safari'
}

/**
 * @description 绑定事件 on(element, event, handler)
 */
export const on = (function () {
  if (document.addEventListener) {
    return function (element, event, handler) {
      if (element && event && handler) {
        element.addEventListener(event, handler, false)
      }
    }
  } else {
    return function (element, event, handler) {
      if (element && event && handler) {
        element.attachEvent('on' + event, handler)
      }
    }
  }
})()

/**
 * @description 解绑事件 off(element, event, handler)
 */
export const off = (function () {
  if (document.removeEventListener) {
    return function (element, event, handler) {
      if (element && event) {
        element.removeEventListener(event, handler, false)
      }
    }
  } else {
    return function (element, event, handler) {
      if (element && event) {
        element.detachEvent('on' + event, handler)
      }
    }
  }
})()

/**
 * 判断一个对象是否存在key，如果传入第二个参数key，则是判断这个obj对象是否存在key这个属性
 * 如果没有传入key这个参数，则判断obj对象是否有键值对
 */
export const hasKey = (obj, key) => {
  if (key) return key in obj
  else {
    let keysArr = Object.keys(obj)
    return keysArr.length
  }
}

/**
 * @param {*} obj1 对象
 * @param {*} obj2 对象
 * @description 判断两个对象是否相等，这两个对象的值只能是数字或字符串
 */
export const objEqual = (obj1, obj2) => {
  const keysArr1 = Object.keys(obj1)
  const keysArr2 = Object.keys(obj2)
  if (keysArr1.length !== keysArr2.length) return false
  else if (keysArr1.length === 0 && keysArr2.length === 0) return true
  /* eslint-disable-next-line */
  else return !keysArr1.some(key => obj1[key] != obj2[key])
}

/**
 * @param {Number} delay
 * @param {Function} callback
 * @description 延时执行
 */
export const delayDev = (delay, callback) => {
    let _callback,
        _delay
    if (Object.prototype.toString.call(delay) === 'object Function') {
        _callback = delay
        _delay = 200
    } else {
        _callback = callback || function () {}
        _delay = delay
    }
    let timer = setTimeout(() => {
        _callback()
        clearTimeout(timer)
        timer = null
    }, _delay)
}

/**
 * @param {Object} obj
 */
export const objLen = (obj) => {
  return Object.keys(obj).length
}

/**
 * @param {Array} arr
 * @description 利用JSON来做深度复制
 */
export const clone = (arr) => {
  let str = JSON.stringify(arr)
  return JSON.parse(str)
}

/**
 * @param {Object} obj
 * @description 对象的复制
 * */
export const objCopy = (obj) => {
  let newObj = {}
  for (let prop in obj) {
    newObj[prop] = obj[prop]
  }
  return newObj
}

/**
 * @param {Object} target 目标对象
 * @param {Object} object 被合并对象
 * @description 对象合并
 */
export const combineObject = (target, object) => {
    return Object.assign(target, object)
}

/**
 * @param {Array} arr
 * @description 对象数组的深度复制
 */
export const deepCopy = (arr) => {
  let newArr = []
  for (let i = 0, len = arr.length; i < len; i++) {
    if (Object.prototype.toString.call(arr[i]) === '[object Object]') {
      newArr.push(objCopy(arr[i]))
    } else {
      newArr.push(arr[i])
    }
  }
  return newArr
}

/**
 * @description 本地连接search部分字符串转化为对象
 */
export const urlSearchToObject = () => {
    let obj = {};
    let str = location.search.substr(1);
    let arr = str.split('&');
    for(let i = 0, len = arr.length; i < len; i++){
        let items = arr[i].split('=');
        obj[items[0]] = decodeURI(items[1]);
    }
    return obj;
}

/**
 * @description 传参
 */
export const searchToObject = search => {
    let obj = {};
    let str = search.substr(1);
    let arr = str.split('&');
    for(let i = 0, len = arr.length; i < len; i++){
        let items = arr[i].split('=');
        obj[items[0]] = decodeURI(items[1]);
    }
    return obj;
}

/**
 * @param {String} str
 * @description 判断字符串中文字符串
 */
export const isChinese = (str) => {
    let pattern = new RegExp("[\u4E00-\u9FA5]+")
    return pattern.test(str)
}

/**
 * @param {String} str
 * @description 判断字符串英文字符串
 */
export const isLetter = (str) => {
    let pattern = new RegExp("[A-Za-z]+")
    return pattern.test(str)
}

/**
 * @param {String} tel
 * @description 判断字符串英文字符串
 */
export const checkTel = (tel) => {
    let reg = /^[1][3-9][0-9]{9}$/
    return reg.test(tel)
}
export const checkEmail= (email)=> {
    const regex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;
    return regex.test(email);
}
export const fuelCardVerify = (num) => {
    let reg = /^\d{19}$/
    return reg.test(num)
}
/**
 * @param {Number} money
 * @description 返回新字符串,格式1,200.00
 */
export const convert = money => {
    let s = money
    s += ''
    if (s.indexOf('.') === -1) s += '.0'
    if (/\.\d$/.test(s)) s += '0'
    while (/\d{4}(\.|,)/.test(s))
        s = s.replace(/(\d)(\d{3}(\.|,))/, '$1,$2')
    return s;
}
/**
 * @param {Number} num
 * @description 返回新字符串,格式1,200
 */
export const thousands = num => {
    return num.toLocaleString()
}
/**
 * @param {String} str
 * @description 手机号隐藏中间四位数 157****0417
 */
export const hideTel = str => {
    let _str = typeof str === 'string' ? str : `${str}`
    let reg = /^(\d{3})\d{4}(\d{4})$/
    return _str.replace(reg, '$1****$2')
}